<span *ngIf="isLoading">
    <div class="emd-loader">
        <div [ngStyle]="{ background: color ? color : '' }"></div>
        <div [ngStyle]="{ background: color ? color : '' }"></div>
        <div [ngStyle]="{ background: color ? color : '' }"></div>
    </div>
</span>
